<template>
  <div class="home">
    <NavBar />
    <transition name="router-animation" enter-active-class="animated fadeInUp">
      <router-view/>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'
import 'animate.css/animate.css';

export default {
  name: 'home',
  components: {
    NavBar
  }
};
</script>
